qtee.customDesign = window.qtee.customDesign || {};

qtee.customDesign.OtherStylesView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/product-otherstyles',
	ui: {
		otherStyleBtns: '.categories .btn',
		tabs: '.tabs li',
		tabSections: '.tabSections section',
		items: '.item'
	},
	events: {
		'click @ui.tabs': 'tabClick',
		'click @ui.items': 'itemClick'
	},
	modelEvents: {
		change: 'render'
	},
	itemClick: function (e) {

		$(qtee.customDesign).triggerHandler('changeSku', { sku: $(e.currentTarget).data('sku') });
		$('body').lpModalClose();

	},
	tabClick: function (e) {

		this.ui.tabs.removeClass('active');
		this.ui.tabSections.hide();

		var sectionId = $(e.currentTarget).addClass('active').data('section');
		$('#' + sectionId).show();

	},
	templateHelpers: function () {

		return {
			selected: parseInt(this.options.selected.split('otherStyle')[1])
		};

	}
});
